/**
 * Endereço próprio do envio de atestado pelo funcionário: atestado.zavy.com.br/<empresa>
 * (atestado.localhost:<porta>/<empresa> em desenvolvimento). Nesse host o app mostra só a página de envio.
 */

const BASE = (import.meta.env.VITE_ENVIO_BASE_URL || 'https://atestado.zavy.com.br').replace(/\/$/, '')

export function ehHostDoEnvio(hostname: string): boolean {
  return hostname.split('.')[0] === 'atestado' && hostname.includes('.')
}

/** "/<empresa>" → slug da empresa; qualquer outro caminho → null. */
export function slugDoCaminho(pathname: string): string | null {
  return pathname.match(/^\/([a-z0-9][a-z0-9-]{0,62})\/?$/)?.[1] ?? null
}

/** Link para divulgar aos funcionários. */
export function linkDoEnvio(slug: string): string {
  return `${BASE}/${slug}`
}

/**
 * Endereço único (o mesmo para todas as empresas: o e-mail diz o cliente, o CPF diz a empresa).
 * Produção tem o subdomínio próprio; dev não tem, e o envio abre em /enviar/_.
 */
export function linkUnico(base: string = BASE): string {
  const b = base.replace(/\/$/, '')
  return b.endsWith('/enviar') ? `${b}/_` : b
}
